<div *ngIf="loadingData && (folders$ | async) === null && (assets$ | async) === null; else assetsTemplate">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    <div class="spinner-holder">
        <loading-indicator></loading-indicator>
    </div>
</div>
<ng-template #assetsTemplate>
    <div class="dashboard-page padded" [class.hosted]="this.hosted" [class.hidden]="currentAsset && hosted">
        <h2 class="header__title no-margin" *ngIf="!this.hosted">
            <app-sidenav-toggle title="Assets"></app-sidenav-toggle>
        </h2>

        <ng-container>
            <div class="container">
                <div class="breadcrumbs" *ngIf="!isRootFolder">
                    <button mat-button class="breadcrumb" (click)="exitFolder()">
                        <h3 class="breadcrumb-text">Folders</h3>
                    </button>
                    <mat-icon>chevron_right</mat-icon>
                    <button mat-button class="breadcrumb">
                        <h3 class="breadcrumb-text">
                            {{ currentFolder }}
                        </h3>
                    </button>
                </div>

                <div *ngIf="isRootFolder">
                    <app-section-title
                        title="Folders"
                        icon="folder"
                        [subtitle]="((foldersPagination$ | async)?.total ?? (folders$ | async)?.length) + ' folders'">
                    </app-section-title>
                    <mat-progress-bar *ngIf="isFoldersLoading$ | async" mode="indeterminate" class="section-progress"></mat-progress-bar>
                    <mat-grid-list class="folders" [cols]="cols" rowHeight="90px" gutterSize="16px">
                        <mat-grid-tile
                            class="folder-wrapper"
                            *ngFor="let folder of folders$ | async"
                            matRipple
                            matRippleColor="primary"
                            (click)="selectFolder(folder.displayName)">
                            <div class="folder">
                                <div class="icon">
                                    <mat-icon>folder_icon</mat-icon>
                                </div>
                                <div class="folder-name-wrap">
                                    <h4 [matTooltip]="folder.displayName">
                                        {{ folder.displayName }}
                                    </h4>
                                    <!--                                    <h5>-->
                                    <!--                                        {{ countNonFolders(folder) }}-->
                                    <!--                                    </h5>-->
                                </div>
                                <!--                                <button-->
                                <!--                                    mat-icon-button-->
                                <!--                                    class="menu"-->
                                <!--                                    (click)="$event.stopPropagation()"-->
                                <!--                                    [matMenuTriggerFor]="folderMenu">-->
                                <!--                                    <mat-icon>more_vert</mat-icon>-->
                                <!--                                </button>-->
                                <!--                                <mat-menu #folderMenu="matMenu">-->
                                <!--                                    <button mat-menu-item (click)="renameFolder(folder.name, folder.id)">-->
                                <!--                                        <mat-icon>edit</mat-icon>-->
                                <!--                                        Rename-->
                                <!--                                    </button>-->
                                <!--                                    <button mat-menu-item (click)="deleteFolder(folder.name, folder.id)">-->
                                <!--                                        <mat-icon>delete</mat-icon>-->
                                <!--                                        Delete-->
                                <!--                                    </button>-->
                                <!--                                </mat-menu>-->
                            </div>
                        </mat-grid-tile>

                        <mat-grid-tile
                            class="folder-wrapper new"
                            matRipple
                            matRippleColor="primary"
                            (click)="openNewFolderDialog()">
                            <div class="folder">
                                <div class="icon">
                                    <mat-icon>create_new_folder_icon</mat-icon>
                                </div>
                                <div class="folder-name-wrap">
                                    <h4>New Folder</h4>
                                    <!--            <h5>-->
                                    <!--              {{folder.numberOfFiles}}-->
                                    <!--            </h5>-->
                                </div>
                            </div>
                        </mat-grid-tile>
                    </mat-grid-list>
                    <ng-container *ngIf="foldersPagination$ | async as fp">
                        <mat-paginator
                            *ngIf="fp.total > fp.limit"
                            [length]="fp.total"
                            [pageSize]="fp.limit"
                            [pageIndex]="fp.page - 1"
                            [hidePageSize]="true"
                            (page)="onFolderPageChange($event.pageIndex + 1)">
                        </mat-paginator>
                    </ng-container>
                </div>
            </div>

            <div class="container" *ngIf="toDisplayFileDrop">
                <h3 class="files-title" *ngIf="isRootFolder">Files</h3>
                <div class="row-centered">
                    <app-file-drop
                        appUploaderProgress
                        [uploadingService]="wsAssetActionService"
                        [accepts]="
                            !this.hosted
                                ? ['.svg', '.png', '.jpeg', '.jpg', '.gif', '.mp4']
                                : dialogType === AssetType.IMAGE
                                  ? ['.svg', '.png', '.jpeg', '.jpg', '.gif']
                                  : ['.mp4']
                        "
                        [uploadAPI]="null"
                        [hideUpload]="true"
                        [toUploadWhenDropped]="false"
                        (filedropped)="wsAssetActionService.uploadAssetAsync($event, this.currentFolder)"
                        (uploadFinished)="uploadFileFinished($event)"></app-file-drop>
                </div>
            </div>
        </ng-container>
        <div class="container" *ngIf="assets$ | async as files">
            <app-section-title
                title="Files"
                icon="insert_drive_file"
                [subtitle]="((assetsPagination$ | async)?.total ?? files?.length) + ' files'">
            </app-section-title>
            <mat-progress-bar *ngIf="isAssetsLoading$ | async" mode="indeterminate" class="section-progress"></mat-progress-bar>
            <mat-grid-list class="files" [cols]="cols" [rowHeight]="hosted ? '250px' : '220px'" gutterSize="16px">
                <mat-grid-tile
                    class="file-wrapper"
                    *ngFor="let file of files"
                    [class.selected]="file === selectedAsset"
                    matRipple
                    matRippleColor="primary">
                    <div class="file">
                        <div class="spinner-holder" *ngIf="file === currentAsset && hosted">
                            <loading-indicator></loading-indicator>
                        </div>
                        <!--                        <div *ngIf="hosted" class="file-hover-text">Select Image</div>-->
                        <dynamic-asset-content [item]="file"></dynamic-asset-content>
                        <div class="file-name-wrap">
                            <h4 [matTooltip]="file.displayName">
                                {{ file.displayName }}
                            </h4>
                            <button
                                mat-icon-button
                                class="menu"
                                (click)="$event.stopPropagation()"
                                [matMenuTriggerFor]="fileMenu">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #fileMenu="matMenu">
                                <button mat-menu-item [matMenuTriggerFor]="moveToFolder">
                                    <mat-icon>drive_file_move</mat-icon>
                                    Move
                                </button>

                                <button
                                    *ngIf="file.canExtendDuration && this.toDisplayExtendVideoOption"
                                    mat-menu-item
                                    (click)="extendVideo(file)">
                                    <mat-icon>edit</mat-icon>
                                    Extend Video
                                </button>
                                <button mat-menu-item (click)="renameFile(file)">
                                    <mat-icon>edit</mat-icon>
                                    Rename
                                </button>
                                <ng-container *ngIf="file.isImage">
                                    <button *ngIf="this.enableEditImage" mat-menu-item (click)="editImage(file)">
                                        <mat-icon>image</mat-icon>
                                        Edit Image
                                    </button>
                                    <button
                                        *ngIf="this.enableImageToVideo"
                                        mat-menu-item
                                        (click)="convertImageToVideo(file)">
                                        <mat-icon>movie_filter</mat-icon>
                                        Create Video
                                    </button>
                                </ng-container>
                                <button mat-menu-item (click)="deleteFile(file)">
                                    <mat-icon>delete</mat-icon>
                                    Delete
                                </button>
                            </mat-menu>

                            <mat-menu #moveToFolder="matMenu">
                                <ng-container *ngIf="folders$ | async as folders">
                                    <button
                                        mat-menu-item
                                        *ngFor="let folder of folders"
                                        (click)="moveFile(file, folder.displayName)"
                                        [disabled]="folder.displayName === file.folder">
                                        {{ folder.displayName }}
                                    </button>
                                </ng-container>
                            </mat-menu>
                        </div>
                        <button *ngIf="hosted && this.toShowSelectAsset" mat-raised-button (click)="selectFile(file)">
                            Select
                        </button>
                    </div>
                </mat-grid-tile>
            </mat-grid-list>
            <ng-container *ngIf="assetsPagination$ | async as ap">
                <mat-paginator
                    *ngIf="ap.total > ap.limit"
                    [length]="ap.total"
                    [pageSize]="ap.limit"
                    [pageIndex]="ap.page - 1"
                    [hidePageSize]="true"
                    (page)="onAssetPageChange($event.pageIndex + 1)">
                </mat-paginator>
            </ng-container>
        </div>
    </div>

    <div class="interaction-blocker" *ngIf="currentAsset && toDisplayLoading">
        <div class="loading-overlay">
            <loading-indicator></loading-indicator>
            <div class="loading-text">Applying changes</div>
            <div class="loading-subtitle">
                Using the {{ currentAsset.mimetype === 'video/mp4' ? 'video' : 'image' }} you selected
            </div>
        </div>
    </div>
</ng-template>
